const leadZero = (num) => (num < 10 ? `0${num}` : num);

export const unixTimeToDate = (date) => {
  if (date.toString().length > 10) {
    return new Date(date);
  }
  return new Date(date * 1000);
};

export const timeToString = (dateString) => {
  if (dateString === null) {
    return 'N/A';
  }
  const date = unixTimeToDate(Date.parse(dateString));
  return `${leadZero(date.getHours())}:${leadZero(date.getMinutes())}`;
};

export const dateToString = (dateString) => {
  if (dateString === null) {
    return 'N/A';
  }
  const date = unixTimeToDate(Date.parse(dateString));
  return `${leadZero(date.getMonth() + 1)}-${leadZero(date.getDate())}-${date.getFullYear()}`;
};

export function identity(value) {
  return value;
}

export function arrayUnique(arr, valueHandler = identity) {
  if (!Array.isArray(arr)) {
    throw new Error('arrayUnique function works only with arrays!');
  }

  const values = arr.map(valueHandler);
  return Array.from(new Set(values));
}

export function fround(value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function formatNumberToLocale({
  number,
  style,
  maximumFractionDigits = 2,
  minimumFractionDigits = 2,
  currencyMaximumFractionDigits = 0,
  currencyMinimumFractionDigits = 0,
}) {
  if (!number) {
    return 'N/A';
  }
  let options = { style };
  if (style === 'currency') {
    options.currency = 'USD';
    options.maximumFractionDigits = currencyMaximumFractionDigits;
    options.minimumFractionDigits = currencyMinimumFractionDigits;
  } else {
    options.maximumFractionDigits = maximumFractionDigits;
    options.minimumFractionDigits = minimumFractionDigits;
  }
  const numberFormat = new Intl.NumberFormat('en-US', options);
  return numberFormat.format(number);
}

export function querystring(name, url = window.location.href) {
  let changedName = name.replace(/[[]]/g, '\\$&');

  const regex = new RegExp('[?&]' + changedName + '(=([^&#]*)|&|#|$)', 'i');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function formatStringToArray(values, defaultValue) {
  if (values === undefined) {
    return defaultValue;
  }
  if (values === '') {
    return [];
  }
  if (Array.isArray(values)) {
    return values;
  }
  if (typeof values === 'string') {
    let arr = [];
    values.split(',').map((phone) => arr.push(phone));
    return arr;
  }
  return defaultValue;
}
